import moment from 'moment';
import Tag from '../../components/lozenge/tags';
import { PopoverModelWrapper } from '../../components/modal/modal.styled';
import Heading from '../../components/typography';
import { TableBodyCellColumn } from '../style/table.styled';
import { DATE_FORMAT } from '../common';
import { ActionButton } from '../../components/vertical-dot/popper';

export const taxPeriodHeader = ({
  actions,
  tableActions,
}: {
  actions?: any;
  tableActions?: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={tableActions}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;

  return [
    {
      Header: 'Tax Period Name',
      accessor: 'name',
      width: 200,
      Cell: ({ row }: any) => (
        <PopoverModelWrapper className='roles-popovers'>
          <Heading variant='body-s' title={row.original.name ?? '-'} />
        </PopoverModelWrapper>
      ),
    },
    {
      Header: 'Tax Period',
      accessor: 'effectiveFrom',
      //   width: 500,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn>
            {`${moment(row.original.effectiveFrom).format(DATE_FORMAT)} - ${moment(
              row.original.effectiveTill
            ).format(DATE_FORMAT)}` ?? '-'}
          </TableBodyCellColumn>
        );
      },
    },

    {
      Header: '',
      accessor: 'actions',
      width: 80,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <ActionButton
            actions={tableActions}
            id={row.original.id}
            rowData={row.original}
            counter={parseInt(row?.id)}
          />
        );
      },
    },
  ];
};
